import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import Search from 'ps-components/Search/Search';
import './RulesListHeader.scss';

class RulesListHeader extends Component {
  static propTypes = {
    clearSearch: func,
    createRule: func,
    getText: func,
    text: string
  };

  render() {
    const { clearSearch, createRule, getText, text } = this.props;

    return (
      <div className="rules__header">
        <div className="rules__header-titlebar">
          <div className="rules__header-name">Market Pricing Rules</div>
          <div onClick={createRule}>
            <a className="rules__link">
              <i className="icon-plus" />
              Create New
            </a>
          </div>
        </div>
        <Search
          className="rules__search"
          id="rules__search"
          onChange={e => getText(e)}
          onClick={clearSearch}
          placeholder="Search by rule name"
          value={text}
        />
      </div>
    );
  }
}

export default RulesListHeader;
